import { graphql, useStaticQuery } from "gatsby"
import React from "react"
import { IPageContext, PageContext } from "../context/PageContext"

let _store: Record<string, string> | null = null

type RoutePathMapData = {
  allSitePage: {
    nodes: Array<{
      path: string
      pageContext: IPageContext
    }>
  }
}

/**
 * Palauttaa polun tuotekategoriasivulle joka vastaa pyydettyä categoryn pimCodea
 */
const useProductCategoryPath = (pimCode?: string, newLocale?: string): string => {
  const { locale } = React.useContext(PageContext)
  const toLocale = newLocale || locale

  const data = useStaticQuery<RoutePathMapData>(
    graphql`
      query DatoCmsProductCategoryPathMap {
        allSitePage(
          filter: {
            componentChunkName: { eq: "component---gatsby-theme-harvia-src-gatsby-templates-dato-product-category-tsx" }
          }
        ) {
          nodes {
            path
            pageContext
          }
        }
      }
    `
  )

  if (_store === null) {
    const pathMap: Record<string, string> = Object.create(null)
    data.allSitePage.nodes.forEach(n => {
      pathMap[`${n.pageContext.pimCode}--${n.pageContext.locale}`] = n.path
    })
    _store = pathMap
  }

  const path = _store[`${pimCode}--${toLocale}`]

  return path && `${path}?search=category:${pimCode}`
}

export default useProductCategoryPath
